import { memo } from 'react';

import './style.sass';

import { Table } from '../common/Table';
import { UserProfile } from 'common/types/models';
import { UserRow } from './UserRow';

type Props = {
    users: UserProfile[],
};

const TABLE_COLUMNS = ['Full Name', 'Date', 'User Type'];

export const UsersTable = memo(({ users }: Props) => {
    if (!users || !users.length) {
        return null;
    }

    return (
        <Table columns={TABLE_COLUMNS} className="users-table">
            {users.map(user => (
                <UserRow userId={user.id} key={user.id} />
            ))}
        </Table>
    );
});

